import React from "react";

const CardSection = (props) => {
    return (
        <div className={`card-section ${props.className}`}>
            <h5 className="card-title">{props.cardTitle}</h5>
            <div className="card-body-sec">{props.children}</div>
        </div>
    );
};

export default CardSection;